export default __webpack_public_path__ + "static/media/welcome.e4fb480b.png";